export default "__VITE_ASSET__BXupOZ6t__"